import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { dashboardOutlets } from '../../helpers/api';
import { dashboardOutletsSuccess, dashboardOutletsError } from './actions';
import { SagaIterator } from '@redux-saga/core';
import { AxiosResponse } from 'axios';
import { DashboardActionTypes } from './constants';

function* dashboardOutletListSaga(): SagaIterator {
    try {
        const response = yield call(dashboardOutlets);
        if (response.data?.data) {
            yield put(dashboardOutletsSuccess(response));
        } else {
            yield put(dashboardOutletsError('Nothing found!'));
        }
    } catch (error: any) {
        yield put(dashboardOutletsError(error?.message));
    }
}

function* watchDashboardOutlets() {
    yield takeEvery(DashboardActionTypes?.DASHBOARD_OUTLETS, dashboardOutletListSaga);
}

function* dashboardOutletsSaga() {
    yield all([fork(watchDashboardOutlets)]);
}

export default dashboardOutletsSaga;
